import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { Insight } from 'src/components/insights/types'
import { TopToolbar } from 'src/components/insights/top-toolbar'
import { InsightLockedActions } from 'src/components/insight-locked/actions'
import { InsightLockedSynopsis } from 'src/components/insight-locked/synopsis'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[6]}px;
  padding-top: ${Shapes.spacing[6]}px;
  max-width: 720px !important;
  margin-inline: auto;
`

type WithOutToolbar = {
  insight: Partial<Insight>
  hideToolbar: true
}
type WithToolbar = {
  insight: Insight
}
type InsightLockedProps = {
  hideToolbar?: boolean
  hasFreeLocations?: boolean
  style?: React.CSSProperties
} & (WithOutToolbar | WithToolbar)

const InsightLocked = (props: InsightLockedProps) => {
  const { insight, hideToolbar, hasFreeLocations = true, style } = props

  return (
    <>
      {!hideToolbar && <TopToolbar insight={insight} color={Colors.textMedium} />}
      <Wrapper>
        <InsightLockedActions style={style} hasFreeLocations={hasFreeLocations} paywall={insight.paywall} />
        <InsightLockedSynopsis style={style} synopsis={insight.paywall?.synopsis} />
      </Wrapper>
    </>
  )
}

export default InsightLocked
